import { useContext, useState } from "react";

// component
import ContactUs from "@/components/contactUs/ContactUs";
import SEO from "@/components/seo/SEO";

// API
import { API, graphqlOperation, withSSRContext } from "aws-amplify";
import { getContactUsInfo } from "@/graphql/queries";
import { createContactUsEnquiry } from "@/graphql/mutations";
// rest api
import { getMerchantData } from "./api/merchant";

// content
import { setToastState } from "@/states/toastBarState";
import Cookies from "universal-cookie";

// context
import MerchantContext from "@/contexts/MerchantContext";
import { getDomainForSSR } from "@/utils/util";

// contact us page
const ContactUsScreen = (props) => {
  const merchantInfoContext = useContext(MerchantContext);
  const cookie = new Cookies();

  const [input, setInput] = useState({
    name: "",
    email: "",
    enquiry: "",
  });

  // handle form submit
  const handleFormSubmit = async () => {
    try {
      var params = {
        contactEmail: input.email,
        contactName: input.name,
        enquiry: input.enquiry,
        merchantId: merchantInfoContext.merchantId,
      };
      const res = await API.graphql(
        graphqlOperation(createContactUsEnquiry, params)
      );
      // clear inputs
      setInput({
        name: "",
        email: "",
        enquiry: "",
      });

      if (res && res.data.createContactUsEnquiry.status === "true") {
        setToastState({
          show: true,
          severity: "success",
          message: res.data.createContactUsEnquiry.message,
        });
      } else {
        setToastState({
          show: true,
          severity: "error",
          message: res.data.createContactUsEnquiry.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <SEO title="Contact Us" keywords="" description="Contact Us" />
      <ContactUs
        stores={props.stores ? props.stores : []}
        contactUsRichText={props.contactUsRichText}
        isEnableEnquiry={props.isEnableEnquiry}
        input={input}
        setInput={setInput}
        handleFormSubmit={handleFormSubmit}
      />
    </>
  );
};

export default ContactUsScreen;

// get stores location
export async function getServerSideProps(context) {
  const { domain, shopId } = getDomainForSSR(context);

  let merchantId = "";
  if (shopId) {
    if (context.req.cookies[`${shopId}@merchantId`]) {
      merchantId = context.req.cookies[`${shopId}@merchantId`];
    } else {
      const merchantJsonData = await getMerchantData(domain);
      merchantId = merchantJsonData.merchantId;
    }
  } else {
    return { notFound: true };
  }

  try {
    var params = {
      merchantId: merchantId,
    };
    const SSR = withSSRContext();
    const res = await API.graphql(graphqlOperation(getContactUsInfo, params));
    if (res.data.getContactUsInfo.status === "true") {
      var returnData = {
        contactUsRichText: res.data.getContactUsInfo.contactUsContent,
        isEnableEnquiry: res.data.getContactUsInfo.contactUsFormEnabled,
      };
      if (res.data.getContactUsInfo.storeList !== null) {
        returnData = {
          ...returnData,
          stores: res.data.getContactUsInfo.storeList,
        };
      }
      return { props: returnData };
    } else {
      return { notFound: true };
    }
  } catch (error) {
    console.log("error", error);
    return { notFound: true };
  }
}
